import React from 'react';
import ScoreIndicator from '../common/ScoreIndicator';

const DecisionView = ({ state }) => {
  const {
    selectedTrend,
    opportunityScore,
    savedResearch,
    openMaiaWithContext,
    approveTrend,
    setDecisionHistory,
    setSelectedTrend,
    setWorkflowStep,
    setActiveView,
    setOpportunityScore,
    setSavedResearch,
  } = state;

  return (
    <div style={{ padding: '32px' }}>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 24, fontWeight: '600', color: '#f3f4f6' }}>HITL Decision Gate</h2>
        <p style={{ margin: '8px 0 0', color: '#9ca3af', fontSize: 14 }}>
          Final opportunity approval {'\u2022'} Strategist review required
        </p>
      </div>

      <div style={{ backgroundColor: '#1e1e32', borderRadius: 12, padding: 32, border: '1px solid #2d2d44', marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32, marginBottom: 32 }}>
          <div style={{ textAlign: 'center' }}>
            <ScoreIndicator score={opportunityScore.overall} size="large" />
            <div style={{ marginTop: 12, fontSize: 14, fontWeight: '600', color: '#f3f4f6' }}>Overall Score</div>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{
              display: 'inline-block',
              padding: '8px 20px',
              borderRadius: 8,
              backgroundColor: opportunityScore.signal === 'green' ? '#065f46' : opportunityScore.signal === 'yellow' ? '#92400e' : '#991b1b',
              color: 'white',
              fontWeight: '700',
              fontSize: 14,
              marginBottom: 12
            }}>
              {opportunityScore.signal.toUpperCase()} LIGHT
            </div>
            <p style={{ margin: 0, fontSize: 15, color: '#d1d5db', lineHeight: 1.6 }}>
              {opportunityScore.recommendation}
            </p>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, paddingTop: 24, borderTop: '1px solid #2d2d44' }}>
          {Object.entries(opportunityScore.factors).map(([key, data]) => (
            <div key={key} style={{ textAlign: 'center' }}>
              <ScoreIndicator score={data.score} />
              <div style={{ marginTop: 8, fontSize: 12, color: '#9ca3af', textTransform: 'capitalize' }}>
                {key.replace(/([A-Z])/g, ' $1')}
              </div>
              <div style={{ fontSize: 11, color: '#6b7280' }}>Weight: {data.weight * 100}%</div>
            </div>
          ))}
        </div>
      </div>

      {/* Research History Section */}
      {savedResearch.length > 0 && (
        <div style={{
          backgroundColor: '#1e1e32',
          borderRadius: 12,
          padding: 24,
          border: '1px solid #2d2d44',
          borderLeft: '4px solid #f59e0b',
          marginBottom: 24
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>
              Saved Research ({savedResearch.length})
            </h3>
            <span style={{ fontSize: 12, color: '#6b7280' }}>Review before final decision</span>
          </div>
          <div style={{ display: 'grid', gap: 12 }}>
            {savedResearch.map(research => (
              <div key={research.id} style={{
                padding: 16,
                backgroundColor: '#252540',
                borderRadius: 8
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                  <div style={{ display: 'flex', gap: 8 }}>
                    {research.agents.map((agent, idx) => (
                      <span key={idx} style={{
                        padding: '2px 8px',
                        backgroundColor: '#374151',
                        borderRadius: 4,
                        fontSize: 11,
                        color: '#9ca3af'
                      }}>
                        {agent}
                      </span>
                    ))}
                  </div>
                  <span style={{ fontSize: 11, color: '#6b7280' }}>{research.timestamp}</span>
                </div>
                <div style={{ fontSize: 13, color: '#d1d5db', marginBottom: 8 }}>
                  <strong>Query:</strong> {research.query}
                </div>
                <div style={{ fontSize: 13, color: '#9ca3af', lineHeight: 1.6 }}>
                  {research.insight.substring(0, 300)}...
                </div>
                <div style={{ marginTop: 8, fontSize: 11, color: '#6b7280' }}>
                  Conducted during: {research.workflowStep}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
        <button
          onClick={() => {
            // Log to decision history
            const declineEntry = {
              id: Date.now(),
              trend: selectedTrend.signal,
              macro: selectedTrend.macro,
              micro: selectedTrend.micro,
              decision: 'declined',
              score: opportunityScore.overall,
              decidedAt: new Date().toLocaleString(),
              decidedBy: 'Trend Strategist',
              routing: null,
              declineReason: 'Strategist decision - did not meet approval criteria'
            };
            setDecisionHistory(prev => [declineEntry, ...prev]);
            // Reset state
            setSelectedTrend(null);
            setWorkflowStep(0);
            setActiveView('dashboard');
            setOpportunityScore(null);
            setSavedResearch([]);
          }}
          style={{
            backgroundColor: 'transparent',
            color: '#ef4444',
            border: '2px solid #ef4444',
            padding: '14px 32px',
            borderRadius: 8,
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: 14
          }}
        >
          Decline Opportunity
        </button>
        <button
          onClick={openMaiaWithContext}
          style={{
            backgroundColor: 'transparent',
            color: '#f59e0b',
            border: '2px solid #f59e0b',
            padding: '14px 32px',
            borderRadius: 8,
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: 14
          }}
        >
          Conduct Deep Research
        </button>
        <button
          onClick={approveTrend}
          style={{
            backgroundColor: '#10b981',
            color: 'white',
            border: 'none',
            padding: '14px 32px',
            borderRadius: 8,
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: 14
          }}
        >
          Approve & Create Brief {'\u2192'}
        </button>
      </div>
    </div>
  );
};

export default DecisionView;
